var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgVegetarian = function SvgVegetarian(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.864 10.823v5.784",
    stroke: "#1B2230",
    strokeWidth: 0.643
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.868 11.474 6.755 7.933l3.113-3.54 2.9 3.54-2.9 3.54Z",
    fill: "#FF5454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.338 12.236a2.758 2.758 0 0 1-.965.625c-.365.14-.759.204-1.16.189a3.19 3.19 0 0 1-1.176-.276 3.378 3.378 0 0 1-1.713-1.713 3.19 3.19 0 0 1-.276-1.176c-.015-.4.05-.795.19-1.16.139-.364.351-.692.624-.965L7.1 9.998l2.238 2.238ZM10.662 12.236c.273.273.601.485.966.625.364.14.758.204 1.16.189.4-.015.8-.109 1.176-.276a3.378 3.378 0 0 0 1.713-1.713c.167-.376.26-.775.275-1.176.015-.4-.05-.795-.189-1.16a2.758 2.758 0 0 0-.625-.965L12.9 9.998l-2.238 2.238Z",
    fill: "#1B2230"
  })));
};
export default SvgVegetarian;